import { componentWithVariants, demoFile } from "system/demo";

import { CLICK, INPUT, story, variant } from "system/demo";
import { PuppetToolsScreen } from 'feature/admin/puppet-test-support';

demoFile('feature/admin/puppet-test-support', {});

componentWithVariants('PuppetToolsScreen', PuppetToolsScreen, {}, [
    variant(null, {
        siloKey: 'puppet-test',
        state: {
            serverCall: {
                puppet: {
                    login: ({puppetSecret, testUserKey}) => 
                        puppetSecret == 'secret' ? Promise.resolve({loginToken: '123'}) : Promise.resolve({loginToken: null}),
                    reset: () => Promise.resolve(null)
                },
            }
        }
    },[
        story('Login with good secret', [
            INPUT('puppet-secret', 'secret'),
            CLICK('Login as User A')
        ]),
        story('Login with bad secret', [
            INPUT('puppet-secret', 'bad'),
            CLICK('Login as User A')
        ]),         
        story('Click all the buttons', [
            INPUT('puppet-secret', 'secret'),
            CLICK('Reset test silo'),
            CLICK('Login as User A'),
            CLICK('Login as User B'),
            CLICK('Login as User C'),  
        ])
    ]),

    variant('Hidden on non-test silo', {})
])

